/*
 * @Author: Alan
 * @Date: 2023-06-14 15:11:45
 * @LastEditors: Connie
 * @LastEditTime: 2023-08-31 14:32:12
 * @Description: 404页面
 * @FilePath: /F1-M2-WEB-Code/components/RestrictAccess/ipError.js
 */
import React from "react";
import Layout from "@/Layout/other";
import { PopUpLiveChat } from "$ACTIONS/util";
//export時會被靜態頁面取代(moveFile.js)
export default function Custom404() {
    return (
        <Layout>
            <div className="error-wrapper">
                <div className="error-img">
                    <img
                        src="/th/img/restrictAccess/restricyAccessImg.jpg"
                        alt="restricyAccessImg"
                    />
                </div>
                <div className="error-right">
                    <div className="error-item">
                        <p className="title">IP ถูกจำกัดการเข้าถึง</p>
                        {/* 访问受限 */}
                        <div className="error-block">
                            <img
                                src="/th/img/restrictAccess/block.png"
                                alt="404Icon"
                            />
                        </div>
                        <span
                            className="error-mes"
                            style={{ textAlign: "center" }}
                        >
                            ภูมิภาคของคุณถูกจำกัดและไม่สามารถเข้าชมเว็บไซต์
                            ของเราได้ ขออภัยในความไม่สะดวก หากมีคำถามใดๆ
                            เพิ่มเติม โปรดติดต่อเจ้าหน้าที่หรือส่งอีเมลหา
                            ฝ่ายบริการลูกค้า
                            {/* 抱歉！您所在的地区受到限制,
                            无法正常游览我们的网站哦。若有不便之处,
                            请多多原谅。若您有任何疑问,
                            请联系我们的在线客服或发邮件 */}
                        </span>
                        <button
                            className="error-btn"
                            onClick={() => PopUpLiveChat()}
                        >
                            <img
                                src="/th/img/error404/service.png"
                                alt="customerServiceIcon"
                            />
                            <span>ฝ่ายบริการลูกค้า</span>
                            {/* 在线客服 */}
                        </button>
                        <div className="error-information">
                            <div className="error-info-text">
                                <span>อีเมล :</span>
                                {/* 电子邮箱: */}
                                <a href="#">cs.thai@fun88.com</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
